export default [
	'finances',
	'home-ownership',
	'lawn-and-garden',
	'maintenance-and-repair',
	'modern-home',
	'remodeling-renovation',
	'selling-a-home',
];
